import React from 'react';
import { ThumbsUp, MessageSquare, Calendar, Anchor } from 'lucide-react';
import StatusBadge from './StatusBadge';

export default function IssueCard({ issue, onClick }) {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className="issue-card" onClick={() => onClick(issue)}>
      <div className="issue-card-header">
        <span className="issue-id">{issue.id}</span>
        <StatusBadge status={issue.status} />
      </div>
      
      <h3 className="issue-card-title">{issue.title}</h3>
      
      <div className="issue-card-meta">
        <span className="category-badge">{issue.category}</span>
        {issue.boatModel && (
          <span className="model-badge">
            <Anchor size={12} />
            {issue.year ? `${issue.year} ` : ''}{issue.boatModel}
          </span>
        )}
      </div>
      
      <p className="issue-card-preview">
        {issue.description?.substring(0, 120)}
        {issue.description?.length > 120 ? '...' : ''}
      </p>
      
      {issue.imageURLs && issue.imageURLs.length > 0 && (
        <img 
          src={issue.imageURLs[0]} 
          alt="Issue" 
          className="issue-card-thumbnail"
          onError={(e) => e.target.style.display = 'none'}
        />
      )}
      
      <div className="issue-card-stats">
        <span className="issue-stat">
          <ThumbsUp size={14} />
          {issue.upvotes || 0}
        </span>
        <span className="issue-stat">
          <MessageSquare size={14} />
          {issue.commentCount || 0}
        </span>
        <span className="issue-stat">
          <Calendar size={14} />
          {formatDate(issue.timestamp)}
        </span>
      </div>
    </div>
  );
}







